import { default as EN_US_STRINGS } from '../constants/strings.en-US';
import { default as FR_CA_STRINGS } from '../constants/strings.fr-CA';
import { default as ES_419_STRINGS } from '../constants/strings.es-419';
import { EN_US, FR_CA, ES_419 } from '../constants/language';
export var getStringsByLanguage = function (language) {
    var defaultString;
    switch (language) {
        case EN_US:
            defaultString = EN_US_STRINGS;
            break;
        case FR_CA:
            defaultString = FR_CA_STRINGS;
            break;
        case ES_419:
            defaultString = ES_419_STRINGS;
            break;
        default:
            console.warn('Taylor Corp - Timeout Widget: No language parameter provided. Defaulting to en-US.');
            defaultString = EN_US_STRINGS;
    }
    return defaultString;
};
